export class CesionFilter {
   public emisorId: string;
   public rutPersonaAutorizada: string = "";
   public dvPersonaAutorizada: string = "";
   public nombrePersonaAutorizada: string = "";
   public fechaDesde: Date;
   public fechaHasta: Date;
   public folio: string = "";
}
